import { render, staticRenderFns } from "./HabeasData.vue?vue&type=template&id=0a85dc30"
import script from "./HabeasData.vue?vue&type=script&lang=js"
export * from "./HabeasData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports